import { render, staticRenderFns } from "./KnowledgePractice.vue?vue&type=template&id=6e384005&scoped=true"
import script from "./KnowledgePractice.vue?vue&type=script&lang=js"
export * from "./KnowledgePractice.vue?vue&type=script&lang=js"
import style0 from "./KnowledgePractice.vue?vue&type=style&index=0&id=6e384005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e384005",
  null
  
)

export default component.exports